import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { IItem, IKeyValue } from '../../models/group-edit-config';
import { CompanyService } from '../../../../services/company.service';
import { CustomErrorStateMatcher } from '../../models/custom-error-state';
import { FormControl } from '@angular/forms';
import { ApiResultValues } from '../../models/apiResultModels';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-input-edit-class',
  templateUrl: './input-edit-class.component.html',
  styleUrls: ['./input-edit-class.component.scss']
})
export class InputEditClassComponent implements OnInit, OnDestroy {
    @Input() config: IItem;
    @Input() control!: FormControl;
    trackingList: IKeyValue[] = [];

    errorMatcher = new CustomErrorStateMatcher();
    sub = new Subject();

    constructor(private comp: CompanyService) { }

    async ngOnInit(): Promise<void> {
        this.comp.ClassTrackingData.pipe(takeUntil(this.sub))
            .subscribe(data => {
                if(data){
                    console.log('InputEditClass: Class tracking data being displayed', data);
                    if(data.length === 0){
                        console.log('InputEditClass: Tracking data array is empty');
                        this.trackingList = [{key: '', value: '** no tracking data found'}];
                    }else{
                        console.log('InputEditClass: Tracking data array has', data.length, 'items');
                        this.trackingList = data;
                    }
                }else{
                    console.log('InputEditClass: Tracking data is null or undefined');
                    this.trackingList = [{key: '', value: '-loading external data'}];
                }
            });

    }

    ngOnDestroy(): void {
        this.sub.next(false);
        this.sub.complete();
    }

}
